/** Components **/
import TableHeaderKeywords from './../../components/Table/TableHeaders/Keywords';
import TableHeaderMyPerfSelect from './../../components/Table/TableHeaders/MyPerfSelect';
import TableHeaderSERP from './../../components/Table/TableHeaders/SERP';

/** JSON */
import globalConfig from './../../assets/json/config.json';

/** Customs columns */
import { LabelColumn } from './customColumns/labelColumn'
import { IntentionColumn } from './customColumns/intentionColumn';
import { PageTypeColumn } from './customColumns/pageTypeColumn';
import { VolumeColumn } from './customColumns/volumeColumn';
import { SerpColumn } from './customColumns/serpColumn';
import { SerpViewerColumn } from './customColumns/serpViewerColumn';
import { PerfsColumn } from './customColumns/perfsColumn';
import { GscIdentifierDateColumn } from './customColumns/gscIdentifierDateColumn';
import { GscImpressionsColumn } from './customColumns/gscImpressionsColumn';
import { GscClicksColumn } from './customColumns/gscClickColumn';
import { GscCtrColumn } from './customColumns/gscCtrColumn';
import { GscPositionColumn } from './customColumns/gscPositionColumn';
import { KDifficultyColumn } from './customColumns/kDifficultyColumn';
import { DecisionsColumn } from './customColumns/decisionsColumn';
import { CategoriesEditorColumn } from './customColumns/categoriesEditorColumn';
import { KeywordCreatedDateColumn } from './customColumns/keywordCreatedDate';
import { EventTypeColumn } from './customColumns/EventTypeColumn';
import { EventSubTypeColumn } from './customColumns/EventSubTypeColumn';
import { EventColumn } from './customColumns/EventColumn';
import { EventStartDateColumn } from './customColumns/EventStartDateColumn';
import { EventEndDateColumn } from './customColumns/EventEndDateColumn';
import { EventScopeColumn } from './customColumns/EventScopeColumn';

/**
 * 
 * @returns array with configuration of header of table in barometer
 */
 export const getCustomColumns = ( appPathName, instanceConfig ) => 
 {
  // get groups for header
  const enabledColumns = globalConfig.barometer.enabled_columns;
  const widthColumns = globalConfig.barometer.width_columns[appPathName];

  // init object with custom Label Component
  const customColumnComponents = {
    LabelColumn: LabelColumn( appPathName, widthColumns ),
    IntentionColumn: IntentionColumn( widthColumns ),
    PageTypeColumn: PageTypeColumn( widthColumns ),
    VolumeColumn: VolumeColumn( appPathName, widthColumns ),
    SerpColumn: SerpColumn( widthColumns ),
    SerpViewerColumn: SerpViewerColumn( widthColumns ),
    PerfsColumn: PerfsColumn( appPathName, widthColumns, instanceConfig ),
    GscIdentifierDateColumn: GscIdentifierDateColumn( widthColumns ),
    GscImpressionsColumn: GscImpressionsColumn( appPathName, widthColumns ),
    GscClickColumn: GscClicksColumn( widthColumns ),
    GscCtrColumn: GscCtrColumn( widthColumns ),
    GscPositionColumn: GscPositionColumn( widthColumns ),
    KDifficultyColumn: KDifficultyColumn( widthColumns ),
    DecisionsColumn: DecisionsColumn( widthColumns ),
    CategoriesEditorColumn: CategoriesEditorColumn( widthColumns ),
    KeywordCreatedDateColumn: KeywordCreatedDateColumn( widthColumns ),
    EventTypeColumn: EventTypeColumn( widthColumns, instanceConfig ),
    EventSubTypeColumn: EventSubTypeColumn( widthColumns, instanceConfig ),
    EventColumn: EventColumn( widthColumns, instanceConfig ),
    EventStartDateColumn: EventStartDateColumn( widthColumns ),
    EventEndDateColumn: EventEndDateColumn( widthColumns ),
    EventScopeColumn: EventScopeColumn( widthColumns )
  }
  
  // init result array
  let result = [];

  /**************************/
  /** Add Le marché column **/
  /**************************/
  if( 
    enabledColumns[appPathName]?.market !== undefined 
    && enabledColumns[appPathName].market.length > 0
  ){
    result.push(
      {
        id: 1,
        disableSortBy: true,
        Header: props => (
          appPathName !== 'urls'
          && appPathName !== 'admin-add-events' ?
            <TableHeaderKeywords 
              {...props.getToggleAllRowsSelectedProps()} 
              id={'massaction'} 
              title={'mot clé'} 
            />
            : null
        ),
        columns: enabledColumns[appPathName].market.map( column => customColumnComponents[column] )
      }
    );  
  }  

  /*********************/
  /** Add SERP column **/
  /*********************/
  if( 
    enabledColumns[appPathName]?.serp !== undefined 
    && enabledColumns[appPathName].serp.length > 0
  ){
    result.push(
      {
        id: 2,
        disableSortBy: true,
        Header: <TableHeaderSERP />,
        columns: enabledColumns[appPathName].serp.map( column => customColumnComponents[column] ).flat()
      }
    );  
  }

  /******************************************/
  /********  Add Performance column *********/
  /******************************************/
  if( 
    enabledColumns[appPathName]?.perfs !== undefined 
    && enabledColumns[appPathName].perfs.length > 0
  ){
    result.push(
      {
        id: 3,
        className: 'column-header-myperf',
        disableSortBy: true,
        Header: <TableHeaderMyPerfSelect />,
        Total: '',
        columns: enabledColumns[appPathName].perfs.map( column => customColumnComponents[column] ).flat()
      }
    );  
  }  

  /**********************************/
  /********  Add GSC column *********/
  /**********************************/
  if( 
    enabledColumns[appPathName]?.gsc !== undefined 
    && enabledColumns[appPathName].gsc.length > 0
  ){
    result.push(
      {
        id: 4,
        disableSortBy: true,
        Header: <h4>ma google search console</h4>,
        columns: enabledColumns[appPathName].gsc.map( column => customColumnComponents[column] )
      }
    );  
  }

  /***********************************************/
  /************* Add DECISION column *************/
  /***********************************************/
  if( 
    enabledColumns[appPathName]?.decisions !== undefined 
    && enabledColumns[appPathName].decisions.length > 0
  ){
    result.push(
      {
        id: 5,
        disableSortBy: true,
        width: widthColumns[4],
        Header: <h4>état</h4>,
        columns: enabledColumns[appPathName].decisions.map( column => customColumnComponents[column] )
      }
    );  
  }

  /************************************************/
  /********  Add Categories Editor column *********/
  /************************************************/
  if( 
    enabledColumns[appPathName]?.categories !== undefined 
    && enabledColumns[appPathName].categories.length > 0
  ){
    result.push(
      {
        id: 6,
        disableSortBy: true,
        Header: <h4>catégories</h4>,
        columns: enabledColumns[appPathName].categories.map( column => customColumnComponents[column] )
      }
    );  
  }

  return result;
 }